import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const SMS_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.SMS,
  false
);

export const getSmsTemplateData = async ({ tenant, cursor, limit, filter }) => {
  const url = `${SMS_BASE}/template/report`;
  const data = await apiClient.post(url, {
    cursor: cursor,
    limit: limit,
    search_text: filter
  });
  // console.log(data, 'data from dynamic api');
  return data;
};

export const getSmsTemplate = async ({ tenant }) => {
  const url = `${SMS_BASE}/template/form`;
  const data = await apiClient.get(url);
  return data;
};

export const createSmsTemplate = async ({ tenant, combinedData }) => {
  const data = await apiClient.post(`${SMS_BASE}/template/`, combinedData);
  return data;
};

export const editSmsTemplate = async ({ tenant, id }) => {
  const data = await apiClient.get(`${SMS_BASE}/template/${id}`);
  return data;
};

export const editSubmitSmsTemplate = async ({ tenant, id, combinedData }) => {
  const data = await apiClient.put(
    `digitization/v1/sms/template/${id}`,
    combinedData
  );
  return data;
};

export const verifySmsTemplate = async ({ tenant, id }) => {
  const data = await apiClient.post(`${SMS_BASE}/template/${id}/verify`);
  return data;
};

export const deleteSmsTemplate = async ({ tenant, id }) => {
  const data = await apiClient.delete(`${SMS_BASE}/template/${id}`);
  return data;
};
